/**
 * Die Funktion, die für bestimmte Embeds Skripte nachladen,
 * werden hier ermittelt und aufgerufen.
 * **/
SWR.Social.prototype.loadSDK = function loadSDK($type) {
  var self = this;

  switch ($type) {
    case ('facebook'):
      self._loadFacebookSDK();
      break;
    case ('instagram'):
      self._loadInstagramSDK();
      break;
    case ('twitter'):
      //self._loadTwitterSDK();
      break;
    case ('mastodon'):
      self._loadMastodonSDK();
      break;
    default:
      console.log("unknown sdk for type ", $type);
      break;
  }
};

/**
 * Wenn das Laden eines Embeds erfolgreich war, wird das
 * HTML in den Platzhalter eingebaut und angezeigt.
 * ***/
SWR.Social.prototype._done = function _done(html) {
  var self = this;

  self.$preview.hide();
  self.$content.html(html).show();
  self.$element.attr({
    'aria-busy': 'false'
  });
  self.$element.removeClass('embed-loading').addClass('embed-loaded');
  self._processing = false;
  self._processed = true;
};

/**
 * Wenn das Laden eines Embeds nicht erfolgreich war, wird ein
 * entsprechendes HTML generiert, in den Platzhalter eingebaut und angezeigt.
 * ***/
SWR.Social.prototype._failed = function _failed(type, url) {
  var self = this;
  var hint = '';
  var html = '';

  switch (type) {
    case 'facebook':
      hint = 'Direkt bei Facebook ansehen';
      break;
    case 'instagram':
      hint = 'Direkt bei Instagram ansehen';
      break;
    case 'twitter':
      hint = 'Direkt beim Kurznachrichtendienst X ansehen';
      break;
    case 'datawrapper':
      hint = 'Datawrapper-Inhalt in neuem Tab/Fenster ansehen';
      break;
    case 'vimeo':
      hint = 'Direkt bei Vimeo ansehen';
      break;
    case 'youtube':
      hint = 'Direkt bei YouTube ansehen';
      break;
    case 'spotify':
      hint = 'Direkt bei Spotify ansehen';
      break;
    case 'giphy':
      hint = 'Direkt bei Giphy ansehen';
      break;
  }

  if (hint !== '') {
    html = COMMON.Utils.template(
      '<div class="alert alert-warning" style="width: 100%; margin: 0;"><p style="margin: 0;">Der Inhalt konnte nicht geladen werden. ' +
      '<a href="{link}" title="Die externe Seite im neuen Tab/Fenster öffnen" target="_blank" rel="external noreferrer noopener">{hint}</a>.</p></div>', {
        link: url,
        hint: hint
      });
  } else {
    html = COMMON.Utils.template(
      '<div class="alert alert-warning" style="width: 100%; margin: 0;"><p style="margin: 0;">Der Inhalt konnte nicht geladen werden.</p></div>', {
        link: url
      });
  }

  self.$preview.hide();
  self.$content.html(html).show();
  self.$element.attr({
    'aria-busy': 'false'
  });
  self.$element.removeClass('embed-loading').addClass('embed-error');
  self._processing = false;
  self._processed = true;
};
